<nz-divider
    *ngIf="!!this.option.displayName"
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #tooltipDescription>
        <div>
            <b>{{ option.displayName }}</b>
            <p
                style="color: #999; white-space: pre-line"
                [innerText]="option.description"
            ></p>
        </div>
    </ng-template>

    <ng-template #text>
        <div
            class="sider-divider-text setting-divider-label"
            nz-tooltip
            [nzTooltipTitle]="option.description ? tooltipDescription : null"
            [nzTooltipOverlayStyle]="{ 'max-width': '380px' }"
        >
            {{ this.option.displayName.toUpperCase() }}
            <span
                *ngIf="option.description"
                class="setting-documentation"
                nz-icon
                nzType="info-circle"
                nzTheme="outline"
            ></span>
        </div>
    </ng-template>
</nz-divider>
<div style="width: 100%">
    <nz-select
        [ngModel]="selectedOption"
        (ngModelChange)="onChange($event)"
        [nzDropdownMatchSelectWidth]="false"
        nzSize="small"
        [nzOptionHeightPx]="25"
    >
        <nz-option
            *ngFor="let option of this.selectOptions"
            [nzValue]="option.value"
            [nzLabel]="option.label"
        ></nz-option>
    </nz-select>
</div>
